import { MediaQueryStyleSheet } from "react-native-responsive";
import { PALETTE } from '../../../constants';

export default MediaQueryStyleSheet.create({

    currencyStyle: {
        color: PALETTE.secondaryActive
    },
    currencyContainerStyle: {
        flex: 1,
        alignItems: 'flex-end',
        color: PALETTE.primaryText,
        marginRight: '-20px'
    }
});